import React from "react";

import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

interface IModifier {
  value: string[];
  options?: any;
  onChangeHandler?: any;
}
const Modifier: React.FC<IModifier> = ({
  value = ["modell"],
  options = { marke: "Opel", modell: "Corsa", farbe_aussen: "Rot" },
  onChangeHandler = () => null,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const topic = event.target.name;
    if (value.includes(topic)) {
      if (value.length === 1) return;
      onChangeHandler(value.filter((e: string) => e !== topic));
    } else {
      onChangeHandler([...value, topic]);
    }
  };

  return (
    <>
      <FormControl component="fieldset" fullWidth margin="none">
        <FormGroup row>
          {Object.entries(options).map(([name, label]) => (
            <FormControlLabel
              key={name}
              control={
                <Checkbox
                  checked={value.includes(name)}
                  onChange={handleChange}
                  name={name}
                />
              }
              label={label}
            />
          ))}
        </FormGroup>
      </FormControl>
    </>
  );
};
export default Modifier;
